"use client";

import React from "react";
import Link from "next/link";
import { cn } from "utils/utils";

type BadgeColor =
  | "primary"
  | "secondary"
  | "accent"
  | "info"
  | "success"
  | "warning"
  | "error"
  | "ghost"
  | "neutral";

type BadgeVariant =
  | `badge-${BadgeColor}`
  | `badge-soft badge-${BadgeColor}`
  | `badge-outline badge-${BadgeColor}`
  | `badge-dash badge-${BadgeColor}`;

interface DockItemProps {
  children: React.ReactNode;
  icon: React.ReactNode;
  isActive: boolean;
  href?: string;
  onClick?: () => void;
  badge?: number | React.ReactNode;
  badgeVariant?: BadgeVariant;
  className?: string;
}

export function DockItem({
  children,
  icon,
  isActive,
  href,
  onClick,
  badge,
  badgeVariant,
  className,
}: DockItemProps) {
  const badgeElement =
    badge !== undefined && badge !== null ? (
      typeof badge === "number" ? (
        badge > 0 ? (
          <span
            className={cn("badge badge-xs", badgeVariant ?? "badge-primary")}
          >
            {badge}
          </span>
        ) : null
      ) : (
        badge
      )
    ) : null;

  const content = (
    <>
      {icon}
      <span className="flex items-center gap-1">
        {children}
        {badgeElement}
      </span>
    </>
  );

  if (href) {
    return (
      <Link
        href={href}
        className={cn(isActive && "dock-active", className)}
      >
        {content}
      </Link>
    );
  }

  return (
    <button
      type="button"
      className={cn(isActive && "dock-active", className)}
      onClick={onClick}
    >
      {content}
    </button>
  );
}
